import { createBaseAsyncThunk } from '../base'
import { Logger } from '@meprism/app-utils'
import { EmailSubscriptionRequest } from './EmailTypes'

export const UpdateEmailSubscription = createBaseAsyncThunk(
  'UpdateEmailSubscription',
  async (payload: EmailSubscriptionRequest ,{ extra }) => {
    try {
        const requestParams = {
            headers: { 'Content-Type': 'application/json' },
            body: payload,
            credentials: 'omit',
            authMode: 'NONE',
        }
       await extra.API.post('EmailUnauthenticated', '/email-subscription', requestParams)
       extra.Toast.show({
        type: 'success',
        text1: `You have successfully unsubscribed from ${payload.template_type.replace(/_/g,' ')}`
       })
    } catch (error) {
      Logger.error(`Error updating subscription status: ${error}`)
      extra.Toast.show({
        type: 'error',
        text1: `Error Unsubscribing from ${payload.template_type.replace(/_/g,' ')}. Try Again.`
      })
    }
  },
)